function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.333h512V426.67H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M301.255 255.996L512 115.499V85.33h-45.255L256 225.826 45.255 85.33H0v30.169l210.745 140.497L0 396.493v30.169h45.255L256 286.166l210.745 140.496H512v-30.169z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M278.261 233.735V85.33h-44.522v116.924l.001 31.481H0v44.522h233.739v148.405h44.522V278.257H512v-44.522H278.262z"
});

const SvgBasqueCountry = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBasqueCountry, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/basque-country.c8293dd8.svg";
export { ForwardRef as ReactComponent };